/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DenyQuarantinedRegistrationDataParser = 
/* #__PURE__ */ parsers.object([['explanation', codecString]]);
export class DenyQuarantinedRegistrationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DenyQuarantinedRegistrationDataParser.decode(input).map(res => new DenyQuarantinedRegistrationData(res));
    }
    static unsafeDecode(input) {
        return DenyQuarantinedRegistrationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DenyQuarantinedRegistrationDataParser.encode(data);
    }
    static schema() {
        return DenyQuarantinedRegistrationDataParser.schema();
    }
}
